import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { UnorderedList } from '@r1-frontend/ui-react/components/List';
import SpeedLineWithDescription from '@r1-frontend/ui-react/organisms/SpeedLine/SpeedLineWithDescription';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Wrapper = styled.div`
    padding: 32px;
    align-items: flex-start;
    flex-direction: column;
    background-color: ${COLORS.BgMain};
    width: 100%;
    border-radius: ${BorderRadius.OuterBlockRadius};

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 24px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        border-radius: ${BorderRadius.componentRadius};
    }
    
    @media (max-width: 375px) {
        padding: 24px 16px;
    }
    
    & > div:nth-child(1) {
        background: none;
        border-radius: 0;
    }
    
    & > div:nth-child(1) > div {
        padding: 0;
    }
`;

export const SpeedLineSelectorWrapper = styled.div`
    display: flex;
    flex-direction: row;
    
    gap: 16px;
    
    & > * {
        width: 100%;
    }
    
    ${UnorderedList} {
        margin-top: 20px;
    }

    @media (min-width: ${wideBreakpoints.laptop}) {
        margin-top: 8px;
    }
`;

export const SSpeedLineWithDescription = styled(SpeedLineWithDescription)`
    margin-top: 12px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: 8px;
    }
`;


export const BtnWrap = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;  
    gap: 12px;
  
    ${Button}:first-child {
        flex-grow: 1;
    }
  
    @media (min-width: ${wideBreakpoints.laptop}) {
        margin-top: 8px;
    }
`;
